// import { CloseButton } from "components/common/Toast";
// import is from "is_js";
import React, { useEffect } from "react";
// import "react-datepicker/dist/react-datepicker.css";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import FalconRoutes from "routes";

// import { useAppContext } from "Main";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  // useAxiosSetup();

  // const HTMLClassList = document.getElementsByTagName("html")[0].classList;
  // const {
  //   config: { navbarPosition },
  // } = useAppContext();

  // useEffect(() => {
  //   if (is.windows()) {
  //     HTMLClassList.add("windows");
  //   }
  //   if (is.chrome()) {
  //     HTMLClassList.add("chrome");
  //   }
  //   if (is.firefox()) {
  //     HTMLClassList.add("firefox");
  //   }
  //   if (is.safari()) {
  //     HTMLClassList.add("safari");
  //   }
  // }, [HTMLClassList]);

  // useEffect(() => {
  //   if (navbarPosition === "double-top") {
  //     HTMLClassList.add("double-top-nav-layout");
  //   }
  //   return () => HTMLClassList.remove("double-top-nav-layout");
  // }, [navbarPosition]);

  return (
    <Router>
      <FalconRoutes />
      {/* <SettingsToggle />
      <SettingsPanel /> */}
      <ToastContainer
        theme="light"
      // closeButton={CloseButton}
      // icon={false}
      // position={toast.POSITION.BOTTOM_LEFT}
      // toastClassName="custom-toast-container"
      // toastContainerClassName="custom-toast-container"
      />
    </Router>
  );
};

export default App;
